import React, { useEffect, useRef } from "react";
import { FiUsers, FiCalendar } from "react-icons/fi";
import { PiBrain, PiUsers } from "react-icons/pi";
import { PiProjectorScreenChartLight, PiCalendarCheckLight } from "react-icons/pi";


const Counter = () => {
  const counterRef = useRef(null);

  useEffect(() => {
    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const valueDisplays = document.querySelectorAll(".num");
          const interval = 4000;

          valueDisplays.forEach((valueDisplay) => {
            let startValue = 0;
            let endValue = parseInt(valueDisplay.getAttribute("data-val"));
            let duration = Math.floor(interval / endValue);
            let counter = setInterval(() => {
              startValue += 1;
              valueDisplay.textContent = startValue;
              if (startValue === endValue) {
                clearInterval(counter);
              }
            }, duration);
          });

          observer.disconnect(); // Stop observing once the counters have started
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5, // Trigger when 50% of the component is visible
    });

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  return (
    <div className="bg-black" ref={counterRef}>
      <div className="w-[75vw] md:w-[78vw] lg:w-[80vw] grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 justify-around gap-2.5 mx-auto py-8 place-items-center">
        <div className="w-[35vmin] h-[35vmin] md:w-[31vmin] md:h-[31vmin] flex flex-col justify-around p-4 relative text-base rounded-full bg-[#121214] border-2 border-[#FF008A]">
          <PiUsers className="fas fa-utensils text-[#f6009c] text-[1.5em] md:text-[2em]  lg:text-[2.5em] mx-auto" />
          <span
            className="num text-white grid place-items-center font-semibold text-[1.5em] md:text-[2em] lg:text-[3em]"
            data-val="236"
          >
            000
          </span>
          <span className="text text-[#e0e0e0] text-[0.775rem] lg:text-lg text-center font-normal leading-none">
            Active Members
          </span>
        </div>

        <div className="w-[35vmin] h-[35vmin] md:w-[31vmin] md:h-[31vmin] flex flex-col justify-around p-4 relative text-base rounded-full bg-[#121314] border-2 border-[#FF008A]">
          <PiCalendarCheckLight className="fas fa-utensils text-[#f6009c] text-[1.5em] md:text-[2em] lg:text-[2.5em] mx-auto" />
          <span
            className="num text-white grid place-items-center font-semibold text-[1.5em] md:text-[2em] lg:text-[3em]"
            data-val="41"
          >
            00
          </span>
          <span className="text text-[#e0e0e0] text-sm text-center font-normal leading-none">
            Events
          </span>
        </div>

        <div className="w-[35vmin] h-[35vmin] md:w-[31vmin] md:h-[31vmin] flex flex-col justify-around p-4 relative text-base rounded-full bg-[#121314] border-2 border-[#FF008A]">
          <PiBrain className="fas fa-utensils text-[#f6009c] text-[1.5em] md:text-[2em] lg:text-[2.5em] mx-auto" />
          <span
            className="num text-white grid place-items-center font-semibold text-[1.5em] md:text-[2em] lg:text-[3em]"
            data-val="23"
          >
            00
          </span>
          <span className="text text-[#e0e0e0] text-sm text-center font-normal leading-none">
            Workshops
          </span>
        </div>

        <div className="w-[35vmin] h-[35vmin] md:w-[31vmin] md:h-[31vmin] flex flex-col justify-around p-4 relative text-base rounded-full bg-[#121314] border-2 border-[#FF008A]">
          <PiProjectorScreenChartLight className="fas fa-utensils text-[#f6009c] text-[1.5em] md:text-[2em] lg:text-[2.5em] mx-auto" />
          <span
            className="num text-white grid place-items-center font-semibold text-[1.5em] md:text-[2em] lg:text-[3em]"
            data-val="17"
          >
            00
          </span>
          <span className="text text-[#e0e0e0] text-sm text-center font-normal leading-none">
            Projects
          </span>
        </div>
      </div>
    </div>
  );
};

export default Counter;
